import React from 'react';
export function MetaPixel() {
  return <noscript data-id="element-16">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1434287821418234&ev=PageView&noscript=1" alt="" data-id="element-17" />
    </noscript>;
}